import { registerAPIService } from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class TWSCustomersApiService extends APIServiceBase {
    constructor() {
        super('TWSCustomers')
    }

    indexPage(data: any) {
        return this.post('IndexPage', data)
    }

    export(target: any, data: any) {
        return this.post('ExportFile?exporterType=' + target, data, 'blob')
    }

    indexExternal() {
        return this.get('IndexExternal', {})
    }
}

registerAPIService(TWSCustomersApiService)